module.exports = __webpack_public_path__ + "img/cover.5413dc9f.jpg";